import React, { FC, ReactElement } from 'react'
import styles from './Brc20DisclaimerModal.module.css'
import IconModal from '@/components/icon-modal'
import AlertCircleIcon from '@/icons/alert'
import { Inscription } from '@/utils/types/inscription'
import Button from '@/components/button'
import ValidateBrc20 from '@/components/validate-brc20'

const Brc20DisclaimerModal: FC<{
	open: boolean
	onClose: () => void
	inscription: Inscription
	owner: string
}> = (props): ReactElement => {
	return (
		<IconModal
			open={props.open}
			onClose={props.onClose}
			title="Double check before purchase"
			titleClassName={styles.title}
			description="Check that this inscription is a real BRC-20 token and not a scam or counterfeit. Once you purchase an inscription, the transaction cannot be reversed."
			descriptionClassName={styles.description}
			icon={() => <AlertCircleIcon className={styles.icon} />}
			bodyClassName={styles.body}
		>
			<ValidateBrc20
				inscription={props.inscription}
				owner={props.owner}
				closeButton={
					<Button background="transparent" onClick={props?.onClose} className={styles.cancelButton}>
						Close
					</Button>
				}
			/>
		</IconModal>
	)
}

export default Brc20DisclaimerModal
